// Where each role lands after login (and when it opens a page it isn't allowed to see)
export const ROLE_HOME = {
  super_admin: '/admin',
  content_manager: '/cms/courses',
  org_admin: '/organisation',
  learner: '/dashboard',
};

export const homePathFor = (role) => ROLE_HOME[role] || '/dashboard';
